import { render } from "./FormEmpresa.vue?vue&type=template&id=98c15262"
import script from "./FormEmpresa.vue?vue&type=script&lang=js"
export * from "./FormEmpresa.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__